import { render, staticRenderFns } from "./PublicEventsContainer.vue?vue&type=template&id=7cf176f1"
import script from "./PublicEventsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicEventsContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports